import React from "react";
import HomePage from "../pages/home/HomePage";
import ResultPage from "../pages/results/ResultsPage";
import { RouteType } from "./config";
import AccountPage from "../pages/account/AccountPage";
import OrganisationsPage from "../pages/organisations/OrganisationsPage";
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import AboutPage from "../pages/about/AboutPage";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BatchesPage from "../pages/batches/BatchesPage";
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import UsersPage from "../pages/users/UsersPage";
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import FeedbackPage from "../pages/feedback/FeedbackPage";
import CustomFieldsPage from "../pages/custom_fields/CustomFieldsPage";
import DashboardCustomize from '@mui/icons-material/DashboardCustomize';
import APIPage from "../pages/api/APIPage";
import APIIcon from '@mui/icons-material/ApiRounded';
import BulkReviewPage from "../pages/results/BulkReviewPage";


const appRoutes: RouteType[] = [
    {
        index: true,
        element: <HomePage />,
        state: "dashboard"
    },
    {
        path: "/dashboard",
        element: <HomePage />,
        state: "dashboard",
        sidebarProps: {
            displayText: "Dashboard",
            icon: <GridViewOutlinedIcon fontSize="large" />,
        },
    },
    {
        path: "/organisations",
        element: <OrganisationsPage />,
        state: "organisations",
        sidebarProps: {
            displayText: "Organisations",
            icon: <HomeWorkOutlinedIcon fontSize="large" />,
        }
    },
    {
        path: "/organisations/:paramID",
        element: <OrganisationsPage />,
        state: "organisations",
    },
    {
        path: "/users",
        element: <UsersPage />,
        state: "users",
        sidebarProps: {
            displayText: "Users",
            icon: <PeopleAltOutlinedIcon fontSize="large" />,
        }
    },
    {
        path: "/users/:paramID",
        element: <UsersPage />,
        state: "users",
    },
    {
        path: "/batches",
        element: <BatchesPage />,
        state: "batches",
        sidebarProps: {
            displayText: "Batches",
            icon: <BallotOutlinedIcon fontSize="large" />,
        }
    },
    {
        path: "/batches/:paramID",
        element: <BatchesPage />,
        state: "batches",
    },
    {
        path: "/results",
        element: <ResultPage />,
        state: "results",
        sidebarProps: {
            displayText: "Results",
            icon: <InsertChartOutlinedIcon fontSize="large" />,
        },
    },
    {
        path: "/results/:paramID",
        element: <ResultPage />,
        state: "results",
    },
    {
        path: "/bulk-review",
        element: <BulkReviewPage />,
        state: "bulk-review",
    },
    {
        path: "/feedback",
        element: <FeedbackPage />,
        state: "feedback",
        sidebarProps: {
            displayText: "Feedback",
            icon: <FeedbackOutlinedIcon fontSize="large" />,
        },
    },
    {
        path: "/feedback/:paramID",
        element: <FeedbackPage />,
        state: "feedback",
    },
    {
        path: "/custom-fields",
        element: <CustomFieldsPage />,
        state: "custom-fields",
        sidebarProps: {
            displayText: "Custom Fields",
            icon: <DashboardCustomize fontSize="large" />,
        },
    },
    {
        path: "/custom-fields/:paramID",
        element: <CustomFieldsPage />,
        state: "custom-fields",
    },
    // {
    //     path: "/account/", // Only For Org Admins
    //     element: <AccountPage />,
    //     state: "account",
    //     sidebarProps: {
    //         displayText: "Account\u00A0Management",
    //         icon: <ManageAccountsOutlinedIcon fontSize="large"/>,
    //       },
    // },
    {
        path: "/swagger-api-keys",
        element: <APIPage />,
        state: "swagger-api-keys",
        sidebarProps: {
            displayText: "API",
            icon: <APIIcon fontSize="large" />
        }
    },
    {
        path: "/swagger-api-keys/:paramID",
        element: <APIPage />,
        state: "swagger-api-keys",
    },
    {
        path: "/about",
        element: <AboutPage />,
        state: "about",
        sidebarProps: {
            displayText: "About",
            icon: <InfoOutlinedIcon fontSize="large" />,
        }
    },
]

export default appRoutes;


// import React from "react";
// import HomePage from "../pages/home/HomePage";
// import ResultPage from "../pages/results/ResultsPage";
// import { RouteType } from "./config";
// import AccountPage from "../pages/account/AccountPage";
// import OrganisationsPage from "../pages/organisations/OrganisaitonsPage";
// import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
// import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
// import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
// import AboutPage from "../pages/about/AboutPage";
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import BatchPage from "../pages/batches/BatchPage";
// import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
// import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
// import UsersPage from "../pages/users/UsersPage";


// const appRoutes: RouteType[] = [
//     {
//         index: true,
//         element: <HomePage />,
//         state: "dashboard"
//     },
//     {
//         path: "/dashboard",
//         element: <HomePage />,
//         state: "dashboard",
//         sidebarProps: {
//             displayText: "Dashboard",
//             icon: <GridViewOutlinedIcon fontSize="large"/>,
//           },
//     },
//     {
//         path: "/organisations",
//         element: <OrganisationsPage />,
//         state: "organisations",
//         sidebarProps: {
//             displayText: "Organisations",
//             icon: <HomeWorkOutlinedIcon fontSize="large"/>,
//         }
//     },
//     {
//         path: "/users",
//         element: <UsersPage />,
//         state: "users",
//         sidebarProps: {
//             displayText: "Users",
//             icon: <PeopleAltOutlinedIcon fontSize="large"/>,
//         }
//     },
//     {
//         path: "/results",
//         element: <ResultPage />,
//         state: "results",
//         sidebarProps: {
//             displayText: "Results",
//             icon: <InsertChartOutlinedIcon fontSize="large"/>,
//           },
//     },
//     {
//         path: "/results/:paramID",
//         element: <ResultPage />,
//         state: "results",
//     },
//     {
//         path: "/account/", // Only For Org Admins
//         element: <AccountPage />,
//         state: "account",
//         sidebarProps: {
//             displayText: "Account\u00A0Management",
//             icon: <ManageAccountsOutlinedIcon fontSize="large"/>,
//           },
//     },
//     {
//         path: "/batches",
//         element: <BatchPage />,
//         state: "batches",
//         sidebarProps: {
//             displayText: "Batches",
//             icon: <InfoOutlinedIcon fontSize="large"/>,
//         }
//     },
//     {
//         path: "/about",
//         element: <AboutPage />,
//         state: "about",
//         sidebarProps: {
//             displayText: "About",
//             icon: <InfoOutlinedIcon fontSize="large"/>,
//           },
//     },
// ]

// export default appRoutes;